import { MenuScene } from "./MenuScene";
import { playIntro, playTitleLogo, skipToIntroLoop } from "../ui/intro";

/**
 * Title / start screen. Heading, captions, background and the Start button are all
 * authored in Tiled (public/assets/maps/menu-title.tmj). On top of that we play the
 * founders' high-five intro (see src/ui/intro.ts): Lucas runs in from the left, Dan
 * from the right, they meet and high-five, then the high-five holds on a loop until
 * the player hits Start. Depth is kept below the Start button (depth 10) so it stays
 * clickable on top.
 */
export class TitleScene extends MenuScene {
  constructor() {
    super("Title");
  }

  create() {
    const [subtitle] = this.buildMenu("menu-title");
    if (subtitle) subtitle.setAlpha(0);
    const startBtn = this.menuButtons[0];
    if (startBtn) startBtn.setAlpha(0).setVisible(false);

    let skipped = false;

    const revealAll = () => {
      if (skipped) return;
      skipped = true;
      skipBtn.destroy();
      intro.destroy();
      skipToIntroLoop(this, { x: 480, y: 380, scale: 1.4, depth: 4, footFrac: 0.923 });
      const logo = playTitleLogo(this, { x: 480, y: 80, scale: 1.1, fps: 12 });
      logo.setAlpha(1);
      if (subtitle) subtitle.setAlpha(1);
      if (startBtn) startBtn.setAlpha(1).setVisible(true);
    };

    const skipBtn = this.add
      .text(920, 510, "Skip ▸", {
        fontFamily: "monospace",
        fontSize: "16px",
        color: "#ffffff",
      })
      .setOrigin(1, 1)
      .setDepth(1000)
      .setAlpha(0.6)
      .setInteractive({ useHandCursor: true })
      .on("pointerover", () => skipBtn.setAlpha(1))
      .on("pointerout", () => skipBtn.setAlpha(0.6))
      .on("pointerdown", revealAll);

    this.input.keyboard!.on("keydown-ESC", revealAll);

    const intro = playIntro(this, {
      x: 480,
      y: 380,
      scale: 1.4,
      depth: 4,
      slideMs: 2500,
      slideFrom: 520,
      footFrac: 0.923,
      startDelay: 1500,
      onHighFive: () => {
        if (skipped) return;
        skipBtn.destroy();
        const logo = playTitleLogo(this, { x: 480, y: 80, scale: 1.1, fps: 12 });
        logo.setAlpha(0);
        this.tweens.add({ targets: logo, alpha: 1, duration: 400 });
        if (subtitle) this.tweens.add({ targets: subtitle, alpha: 1, duration: 400, delay: 500 });
        if (startBtn) {
          this.tweens.add({
            targets: startBtn,
            alpha: 1,
            duration: 400,
            delay: 1000,
            onStart: () => startBtn.setVisible(true),
          });
        }
      },
    });
  }
}
